<div class="layoutBlock">
    <div class="columnHalf">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.generalData' | hisUi}}"
            [toggleable]="false">
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.contactPerson"
                    class="inputWidth100" [(ngModel)]="furtherDetails.availabilityFreetext"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.travelCompanion"
                    class="inputWidth100" [(ngModel)]="furtherDetails.travelCompanionFreetext"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.travelCompanionExplanation"
                    class="inputWidth100" [(ngModel)]="furtherDetails.travelCompanionExplanationFreetext"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.instituteFirst"
                    styleClass="autocompleteWidth100" field="text" [(ngModel)]="furtherDetails.instituteFirstSelected"
                    hisEagerDataSource="api/v1/rm/erp/travelmanagement/values/erptravelmanagementnotes"
                    [forceSelection]="true" (ngModelChange)="onModelChange($event)">
                </p-autoComplete>
            </his-plam>
            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.instituteSecond"
                    styleClass="autocompleteWidth100" field="text" [(ngModel)]="furtherDetails.instituteSecondSelected"
                    hisEagerDataSource="api/v1/rm/erp/travelmanagement/values/erptravelmanagementnotes"
                    [forceSelection]="true" (ngModelChange)="onModelChange($event)">
                </p-autoComplete>
            </his-plam>
        </p-panel>
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.guestFromAbroad' | hisUi}}"
            [toggleable]="false">
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.teachingCurriculum"
                    [(ngModel)]="furtherDetails.teachingActivityInCurriculum" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.valuableConsiderationForTeaching"
                    [(ngModel)]="furtherDetails.valueableConsiderationForTeaching" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
        </p-panel>

    </div>
    <div class="columnHalf">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.accommodationInformation' | hisUi}}"
            [toggleable]="false">
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.costsHigherStaedtekatalog"
                    [(ngModel)]="furtherDetails.costsHigherStaedtekatalog" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.reasonCostsHigherStaedtekatalog"
                    class="inputWidth100" [(ngModel)]="furtherDetails.reasonCostsHigherStaedtekatalog"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.addressTravelDestination"
                    class="inputWidth100" [(ngModel)]="furtherDetails.addressTravelDestination"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
        </p-panel>
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.notes' | hisUi}}"
            [toggleable]="false">

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.notesSelected"
                    styleClass="autocompleteWidth100" field="text" [(ngModel)]="furtherDetails.notesSelected"
                    hisEagerDataSource="api/v1/rm/erp/travelmanagement/values/erptravelmanagementnotes"
                    [forceSelection]="true" (ngModelChange)="onModelChange($event)">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails.notes"
                    [(ngModel)]="furtherDetails.notes" (ngModelChange)="onModelChange($event)" class="textareaWidth100"
                    rows="5"></textarea>
            </his-plam>

        </p-panel>
    </div>
</div>